/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { FlagResponse } from "../types/FlagResponse";
export const Response = core.serialization.list(FlagResponse);
